module.exports = __webpack_public_path__ + "media/assets/player/playlist-14abe76f195921cfaf8efdaa91b29f1e.png";